import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useProductStore } from "../../store/productStore";
import { AddProductModal } from './AddProductModal';

export const ProductToolbar = () => {
  const { t } = useTranslation();
  const searchQuery = useProductStore((state) => state.searchQuery);
  const setSearchQuery = useProductStore((state) => state.setSearchQuery);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 py-4 px-4 md:px-6 bg-white rounded-xl">
        <div className="w-full md:w-auto flex gap-2">
          <input
            type="text"
            className="input input-bordered w-full md:w-96"
            placeholder={t("products.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              className="btn btn-ghost"
              onClick={() => setSearchQuery("")}
            >
              {t("products.clearFilter")}
            </button>
          )}
        </div>
        <div className="w-full md:w-auto">
          <button
            className="btn btn-primary w-full md:w-auto"
            onClick={() => setIsModalOpen(true)}
          >
            {t("products.addNew")}
          </button>
        </div>
      </div>

      <AddProductModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}; 